import type { InputPuzzle } from "./puzzle.types";

export const AMATEUR_PUZZLES: InputPuzzle[] = [
  {
    p: "104035000590600381806079004000720900005008132240513008010004009452967810960280450",
    s: "124835796597642381836179524381726945675498132249513678718354269452967813963281457",
    d: -20967,
  },
  {
    p: "120006507097120300030704021040501070506040010008970405000607209000280146263419758",
    s: "124836597697125384835794621942561873576348912318972465481657239759283146263419758",
    d: -20967,
  },
  {
    p: "120004097080009403043071625402903750300145006801700900504600170090317502207400000",
    s: "126534897785269413943871625462983751379145286851726934534692178698317542217458369",
    d: -20979,
  },
  {
    p: "100003900074092130305004726000006802000758000600000574009025081458931267231867000",
    s: "126573948874692135395184726517346892942758613683219574769425381458931267231867459",
    d: -20979,
  },
  {
    p: "026005040590310608073906005087291506039008002015673890950804260042509001008020000",
    s: "126785943594312678873946125487291536639458712215673894951834267742569381368127459",
    d: -20967,
  },
  {
    p: "020000769406009030050720040600970384000304612200081950830195476790460003564000800",
    s: "128543769476819235359726148615972384987354612243681957832195476791468523564237891",
    d: -20979,
  },
  {
    p: "130840005589060200000910803940080352862034007351209004003000020200601439490000716",
    s: "136842975589763241724915863947186352862534197351279684613497528278651439495328716",
    d: -20979,
  },
  {
    p: "138020970007600812290070040971856200864002009320041087782019000010060790600407000",
    s: "138524976547693812296178543971856234864732159325941687782319465413265798659487321",
    d: -20979,
  },
  {
    p: "030954700465000091079018345302001450000543268040029003000070902090102000720095684",
    s: "138954726465237891279618345382761459917543268546829173853476912694182537721395684",
    d: -20979,
  },
  {
    p: "130904020204800190050072000582003000709081600013047958825409307391006580400058200",
    s: "138964725274835196956172843582693471749581632613247958825419367391726584467358219",
    d: -20967,
  },
  {
    p: "039520760578040910400000350724006805683000400050034007000400503395187006040352079",
    s: "139528764578643912462791358724916835683275491951834627217469583395187246846352179",
    d: -20979,
  },
  {
    p: "039640807672009001084173096240500000357981640001006000005368724000715060700200180",
    s: "139642857672859431584173296246537918357981642891426573915368724428715369763294185",
    d: -20967,
  },
  {
    p: "142835906390006850560017002000090420026100709059000610070000003934561287685720000",
    s: "142835976397246851568917342713698425826154739459372618271489563934561287685723194",
    d: -20967,
  },
  {
    p: "043005908200089306090132470000308007000060890006904201020810643067000180031246759",
    s: "143675928275489316698132475914328567352761894786954231529817643467593182831246759",
    d: -20979,
  },
  {
    p: "040000972000000010069007385582031697406020050003560008024810769951276004670304000",
    s: "145683972837952416269147385582431697496728153713569248324815769951276834678394521",
    d: -20979,
  },
  {
    p: "100030926629415730807069014096020800001748209278506143004600095980000002500000000",
    s: "145837926629415738837269514496321857351748269278596143714682395983154672562973481",
    d: -20979,
  },
  {
    p: "140869027807002014032047058000600000016000872428700500569200780071300495380970000",
    s: "145869327897532614632147958753628149916453872428791536569214783271386495384975261",
    d: -20979,
  },
  {
    p: "000820030032914076800050000020546017060100295700000004605730421400285060273461950",
    s: "146827539532914876897653142928546317364178295751392684685739421419285763273461958",
    d: -20979,
  },
  {
    p: "140235689239000040568410207090058001716300000854091070600900000083100090901063824",
    s: "147235689239876145568419237392758461716342958854691372625984713483127596971563824",
    d: -20967,
  },
  {
    p: "000632050006507012200480736971250608328706001465800070000000065014000927690100384",
    s: "147632859836597412259481736971253648328746591465819273783924165514368927692175384",
    d: -20967,
  },
  {
    p: "040035080038000007256080403503864209820319000000500300760108930005407826409023571",
    s: "147935682938246157256781493573864219824319765691572348762158934315497826489623571",
    d: -20967,
  },
  {
    p: "040903200036425070005010403010006900582391007090078002008030720261704309009860514",
    s: "147983265936425871825617493713246958582391647694578132458139726261754389379862514",
    d: -20979,
  },
  {
    p: "108206397007039851590187200031602980700005014059801030020060009000020068800904520",
    s: "148256397267439851593187246431672985782395614659841732324568179915723468876914523",
    d: -20979,
  },
  {
    p: "000000007059020041320514896060905004900430670080760050001670405006208703874153962",
    s: "148396527659827341327514896762985134915432678483761259231679485596248713874153962",
    d: -20967,
  },
  {
    p: "048000030297804500365971280080462157052090040010587090076040010839000400000059670",
    s: "148625739297834561365971284983462157752193846614587392576248913839716425421359678",
    d: -20979,
  },
  {
    p: "002008900800005610760140852410030076239756481600014030940200360007460190306001004",
    s: "152678943894325617763149852418932576239756481675814239941287365527463198386591724",
    d: -20967,
  },
  {
    p: "103497806204580197009261304640802009572009630008000002805904000490305281000010000",
    s: "153497826264583197789261354641832579572149638938756412815924763496375281327618945",
    d: -20979,
  },
  {
    p: "004902783207140605086503412740605139005480006020317000401000007062001340073000960",
    s: "154962783237148695986573412748625139315489276629317854491836527562791348873254961",
    d: -20967,
  },
  {
    p: "100630920483900015200815730700090506008000002900520071805263000601409053320107069",
    s: "157634928483972615269815734742391586518746392936528471895263147671489253324157869",
    d: -20979,
  },
  {
    p: "108000946090846130306105870735902060480670500029050700000000050000039081872561394",
    s: "158327946297846135346195872735912468481673529629458713913284657564739281872561394",
    d: -20967,
  },
  {
    p: "158790634492000710003000520210803956067025001000014070930007465026409183840000000",
    s: "158792634492536718673148529214873956367925841589614372931287465726459183845361297",
    d: -20967,
  },
  {
    p: "059203000008170360736948501003687294967520800082390000801000000000000085395002746",
    s: "159263478248175369736948521513687294967524813482391657871456932624739185395812746",
    d: -20979,
  },
  {
    p: "109634720048700003730080040021460080007910205905208431892040370000097052003020100",
    s: "159634728248759613736182549321465987487913265965278431892541376614397852573826194",
    d: -20979,
  },
  {
    p: "003080500297513600800209701032070910600051870700092345920138000371000258400700003",
    s: "163487529297513684854269731532874916649351872718692345925138467371946258486725193",
    d: -20979,
  },
  {
    p: "163705924000019806097020350720050000304001007010072435005136742401090003030047180",
    s: "163785924542319876897624351729453618354861297618972435985136742471298563236547189",
    d: -20967,
  },
  {
    p: "164020050300475210052160004601592837000008600287046190006007003503684001409000060",
    s: "164823759398475216752169384641592837935718642287346195816957423523684971479231568",
    d: -20979,
  },
  {
    p: "160082073380000924502437681043070890000203006720060005236018059908006200071020008",
    s: "164982573387651924592437681643175892815293746729864135236718459958346217471529368",
    d: -20967,
  },
  {
    p: "000728394708450000342610700001064837400080200687100040076040003000005601819376425",
    s: "165728394798453162342619758921564837453987216687132549576241983234895671819376425",
    d: -20967,
  },
  {
    p: "160800030000007826000603095908516203750090614000204500204900350001035902503482761",
    s: "165829437439157826827643195948516273752398614316274589274961358681735942593482761",
    d: -20967,
  },
  {
    p: "160530008003100476040002013402058030730490125090013047000001082981025004306800951",
    s: "167534298253189476849672513412758639738496125695213847574961382981325764326847951",
    d: -20967,
  },
  {
    p: "070805490400327851005009670010203069706001200003570148007030926090002080204698500",
    s: "172865493469327851385419672518243769746981235923576148857134926691752384234698517",
    d: -20979,
  },
  {
    p: "103002400086403000050610009000020004094380712068041003015800027329107840847205136",
    s: "173952468986473251452618379731529684594386712268741593615834927329167845847295136",
    d: -20967,
  },
  {
    p: "170980560058002701269750308040095000032070915090263087080040129014820000300510000",
    s: "173984562458632791269751348847195236632478915591263487785346129914827653326519874",
    d: -20979,
  },
  {
    p: "070350098600012735500987146280005009709123600410090020045261003301074050007500000",
    s: "174356298698412735532987146286745319759123684413698527945261873361874952827539461",
    d: -20979,
  },
  {
    p: "170080900260943187000106402319057040457308090020000000040805019000210563531069800",
    s: "174582936265943187983176452319657248457328691826491375642835719798214563531769824",
    d: -20979,
  },
  {
    p: "000630928520100607038097000483019502007062081201800704800300200340506809706900053",
    s: "174635928529184637638297145483719562957462381261853794895341276342576819716928453",
    d: -20979,
  },
  {
    p: "100609082030400500206108470000091623301025940927000850512964038798003064640000000",
    s: "174659382839472516256138479485791623361825947927346851512964738798513264643287195",
    d: -20967,
  },
  {
    p: "170903500630058000280016900006074250503100807701082006050801020312697405400030019",
    s: "174923568639458172285716934896374251523169847741582396957841623312697485468235719",
    d: -20979,
  },
  {
    p: "105026804239580060648010592006000001403790080821635000062079010010450000304100970",
    s: "175926834239584167648317592796248351453791286821635749562879413917453628384162975",
    d: -20979,
  },
  {
    p: "076005429003070000008019000942037600651908372387060194209056780760090241800000000",
    s: "176385429593274816428619537942137658651948372387562194219456783765893241834721965",
    d: -20979,
  },
  {
    p: "106049080529803710800001569008030601300074958967185042703250096205400000001000000",
    s: "176549283529863714834721569458932671312674958967185342743258196295416837681397425",
    d: -20979,
  },
  {
    p: "100000400985017302400500871060008034729350186300176520000093000093645200650280043",
    s: "176832495985417362432569871561928734729354186348176529214793658893645217657281943",
    d: -20967,
  },
  {
    p: "000482600853970124204350807001007002507894061038200000700028035300740016912000708",
    s: "179482653853976124264351897491637582527894361638215479746128935385749216912563748",
    d: -20967,
  },
  {
    p: "080743609794526038003008427901870000006431590300602071610359004408260000000000063",
    s: "182743659794526138563918427921875346876431592345692871617359284438267915259184763",
    d: -20967,
  },
  {
    p: "003029000026000953459003128030012860290086345864030010602390081070050004010060297",
    s: "183529476726148953459673128537412869291786345864935712642397581978251634315864297",
    d: -20967,
  },
  {
    p: "103760050026305087759008300900457010005620093610809572300102000568940001200500038",
    s: "183764259426395187759218364932457816875621493614839572397182645568943721241576938",
    d: -20967,
  },
  {
    p: "184000607259007400730100529410579200008300014000000753301006092025493100607080345",
    s: "184925637259637481736148529413579268578362914962814753341756892825493176697281345",
    d: -20967,
  },
  {
    p: "080007402290010600467050908602100387000780059879000146010003800534029701728601000",
    s: "185967432293418675467352918652194387341786259879235146916573824534829761728641593",
    d: -20979,
  },
  {
    p: "180403020700520000532000094071600830463200009200309060020954008015782003094136057",
    s: "186493725749521386532867194971645832463218579258379461327954618615782943894136257",
    d: -20979,
  },
  {
    p: "007309000654000900003856007460130879700498236900070040020087650879064321046000700",
    s: "187349562654721983293856417462135879715498236938672145321987654879564321546213798",
    d: -20979,
  },
  {
    p: "089306040703941620240875031862009073010760080005408062098603250020000390037000000",
    s: "189326745753941628246875931862159473314762589975438162498613257621587394537294816",
    d: -20979,
  },
  {
    p: "009503006000681409340090005005408001403006082900257643854300160730104008091005324",
    s: "189543276527681439346792815265438791473916582918257643854329167732164958691875324",
    d: -20967,
  },
  {
    p: "190304078005800003036001045900702480608905030200683000580437201367029050421500000",
    s: "192354678745896123836271945953712486618945732274683519589437261367129854421568397",
    d: -20979,
  },
  {
    p: "193200640400030079680000321009000103560301297318092056006807514200504030000913060",
    s: "193278645452136879687459321729645183564381297318792456936827514271564938845913762",
    d: -20967,
  },
  {
    p: "003785240580423917740600300308060120927040863060208000239050470005070000670800501",
    s: "193785246586423917742619385358967124927541863461238759239156478815374692674892531",
    d: -20967,
  },
  {
    p: "190305208800260934002489750209700000430902080700600402620090000907006105583027640",
    s: "194375268875261934362489751259748316436912587718653492621594873947836125583127649",
    d: -20979,
  },
  {
    p: "000036008000124000326905700657800030009570604408602007001200493083461270542397000",
    s: "194736528875124369326985741657849132219573684438612957761258493983461275542397816",
    d: -20979,
  },
  {
    p: "005200647042910058807056920953841700080765000706300405009000836400580000028000514",
    s: "195238647642917358837456921953841762284765193716392485579124836461583279328679514",
    d: -20979,
  },
  {
    p: "195830742060490180008010003906705310700260050051300276000104028402003500519020407",
    s: "195836742367492185248517693926785314734261859851349276673154928482973561519628437",
    d: -20967,
  },
  {
    p: "003506700876009305000070018000960857657040190009735402020600001700053080061827934",
    s: "213586749876419325945372618432961857657248193189735462328694571794153286561827934",
    d: -20979,
  },
  {
    p: "214079853300058170508032694400000000030907200060285437700800506003004029102090048",
    s: "214679853396458172578132694427361985835947261961285437749823516683514729152796348",
    d: -20979,
  },
  {
    p: "210087095000924008098000024060098713907510800801063000105070062026050000379246581",
    s: "214687395653924178798135624562498713937512846841763259185379462426851937379246581",
    d: -20967,
  },
  {
    p: "000039007009107352070256900706004030930000078180793000540362001397501080621000543",
    s: "215439867469187352873256914756824139932615478184793625548362791397541286621978543",
    d: -20979,
  },
  {
    p: "015009076003500249904027003659701320072340005400900060520164030007090000096073452",
    s: "215439876763518249984627513659781324872346195431952768528164937347295681196873452",
    d: -20979,
  },
  {
    p: "215806903308502016704000085650700100002900030070401059501389704406207391037600000",
    s: "215846973398572416764193285659738142142965837873421659521389764486257391937614528",
    d: -20967,
  },
  {
    p: "206000453070516920000243671039124580080700302502608000805471009307060004090000065",
    s: "216897453473516928958243671739124586681759342542638197865471239327965814194382765",
    d: -20979,
  },
  {
    p: "000000078030108042000275061300714006640389705178602493580420600060537280400006007",
    s: "216943578735168942894275361359714826642389715178652493587421639961537284423896157",
    d: -20967,
  },
  {
    p: "200309645430005001950710200301976502609030004870001306063147029000600000192853060",
    s: "217389645438265971956714238341976582629538714875421396563147829784692153192853467",
    d: -20967,
  },
  {
    p: "200080956980075000350962081401090027695704810728501094572008000000009270060200048",
    s: "217483956986175432354962781431896527695724813728531694572348169843619275169257348",
    d: -20967,
  },
  {
    p: "007904000008230790593701840070090234020610087030007000400000900760852410382149675",
    s: "217984356648235791593761842176598234924613587835427169451376928769852413382149675",
    d: -20979,
  },
  {
    p: "008000000400312508357600024001004706000830240000971800190240657742000980086793412",
    s: "218457369469312578357689124831524796975836241624971835193248657742165983586793412",
    d: -20979,
  },
  {
    p: "018547039009300870000080250951406382864053007700108000005009006187004000002735148",
    s: "218547639549362871376981254951476382864253917723198465435819726187624593692735148",
    d: -20979,
  },
  {
    p: "208045003069023541304096000501300080026080305840901200400600702607230100132500694",
    s: "218745963769823541354196827571362489926487315843951276485619732697234158132578694",
    d: -20967,
  },
  {
    p: "210074000854300709000000014028706150541008260673200008307192845105483602082000000",
    s: "219574386854361729736829514928746153541938267673215498367192845195483672482657931",
    d: -20967,
  },
  {
    p: "230004896005832170748100523052000740807049001009270008103920407574360082000000005",
    s: "231754896695832174748196523352618749867549231419273658183925467574361982926487315",
    d: -20967,
  },
  {
    p: "230900045690048001804320000003860002506137408000250063065703124310492057742000000",
    s: "231976845697548231854321976473869512526137498189254763965783124318492657742615389",
    d: -20967,
  },
  {
    p: "200001008605892103891307052980000530063759000542003000000000010309200476418976325",
    s: "234561798675892143891347652987624531163759284542183967726435819359218476418976325",
    d: -20967,
  },
  {
    p: "234000007900827045857039100379215486001070203542380000060502004003700000000140628",
    s: "234651897916827345857439162379215486681974253542386971168592734423768519795143628",
    d: -20979,
  },
  {
    p: "235007046046930078780060001600080504857040600490356000904501080302098160008073002",
    s: "235817946146935278789264351623789514857142639491356827964521783372498165518673492",
    d: -20979,
  },
  {
    p: "036415709519300062800020135053780091120009004090001673940800007080007906701002048",
    s: "236415789519378462874926135653784291127639854498251673942863517385147926761592348",
    d: -20967,
  },
  {
    p: "230478901850003074007000203970204100680730592512860300000580730090300010068010025",
    s: "236478951859123674147695283973254168684731592512869347421586739795342816368917425",
    d: -20979,
  },
  {
    p: "237500146840612070165030090500973621070200030010006759490120560701060004050007003",
    s: "237589146849612375165734892584973621976251438312846759493128567721365984658497213",
    d: -20967,
  },
  {
    p: "007960015856010000009025070700581632320607059065090008580000403602400501003156287",
    s: "237964815856713924419825376794581632328647159165392748581279463672438591943156287",
    d: -20967,
  },
  {
    p: "038009100650002009079850200895003401060491007007528093023064078500987012780230000",
    s: "238749165654312789179856234895673421362491857417528693923164578546987312781235946",
    d: -20967,
  },
  {
    p: "040008070159670048687009000000810002800490736000307050061720003034506107728931564",
    s: "243158679159673248687249315376815492815492736492367851561724983934586127728931564",
    d: -20967,
  },
  {
    p: "043019570905408000018070000762300090401007002059102063506034089104000230387201045",
    s: "243619578975428316618573924762385491431967852859142763526734189194856237387291645",
    d: -20979,
  },
  {
    p: "240300718019075463360018090602980145080654230000000087006892370000700800000036924",
    s: "245369718819275463367418592632987145781654239594123687456892371923741856178536924",
    d: -20967,
  },
  {
    p: "245008916080194005007500304500603000830240650762000143008730501050802407673050200",
    s: "245378916386194725917526384594613872831247659762985143428739561159862437673451298",
    d: -20967,
  },
  {
    p: "206051930900600714710948000027410086060870300080500427032000079800390040694087100",
    s: "246751938958623714713948265327419586465872391189536427532164879871395642694287153",
    d: -20979,
  },
  {
    p: "000506000836102594590804000025000783408057926900260051384025070159080600760410000",
    s: "247596318836172594591834267625941783418357926973268451384625179159783642762419835",
    d: -20967,
  },
  {
    p: "240691073371452600596080012482310950030506000650000201800274369060000000703008005",
    s: "248691573371452698596783412482317956139526784657849231815274369964135827723968145",
    d: -20967,
  },
  {
    p: "000007060060358400531000809016000307054001298729480651483570126002034785170000000",
    s: "248917563967358412531642879816295347354761298729483651483579126692134785175826934",
    d: -20967,
  },
  {
    p: "249108507780025039013790000008910052490600000005070300604287005800000703957341286",
    s: "249138567786425139513796428378914652492653871165872394634287915821569743957341286",
    d: -20967,
  },
  {
    p: "009100867863070009100896200485607001600004005372510486030021540504300002908700003",
    s: "249153867863472159157896234485637921691284375372519486736921548514368792928745613",
    d: -20979,
  },
  {
    p: "009005071508907064076040985400186007190523806600794003002000630000602010001378452",
    s: "249865371518937264376241985423186597197523846685794123752419638834652719961378452",
    d: -20967,
  },
  {
    p: "001007000040050026980243001890010604002076100005030902078600519124095308569080247",
    s: "251867493743159826986243751897512634432976185615438972378624519124795368569381247",
    d: -20979,
  },
  {
    p: "050879040090200007040051928083090415705406830904085670160040093002000501530028060",
    s: "251879346896234157347651928683792415725416839914385672168547293472963581539128764",
    d: -20979,
  },
  {
    p: "251063780704128000068704002803090001045080670920400803030600018587001900619000407",
    s: "251963784794128365368754192873596241145382679926417853432679518587241936619835427",
    d: -20979,
  },
  {
    p: "000096470060004513800730000506400389418003260900600145004519720692300851005860004",
    s: "253196478769284513841735692526471389418953267937628145384519726692347851175862934",
    d: -20967,
  },
  {
    p: "050070194890240506600003802301069207760084051080107063906418325105002640000000000",
    s: "253876194897241536614953872341569287762384951589127463976418325135792648428635719",
    d: -20979,
  },
  {
    p: "254300819006800030108409060060043180020058476000067392002000908580704620419600700",
    s: "254376819796815234138429567967243185321958476845167392672531948583794621419682753",
    d: -20979,
  },
  {
    p: "256030009800090300090514086908452730070083460003761598781320654600000000530000907",
    s: "256837149814296375397514286968452731175983462423761598781329654649175823532648917",
    d: -20967,
  },
  {
    p: "056803070000041360010762089930200800400058290000904650149000708680139005523080016",
    s: "256893174798541362314762589935276841461358297872914653149625738687139425523487916",
    d: -20979,
  },
  {
    p: "000600081900107540601908723500203879729480000063705402302076150400000200080300697",
    s: "257634981938127546641958723514263879729481365863795412392876154476519238185342697",
    d: -20979,
  },
  {
    p: "200008140013045729000127005501806270038402690000370050065000030300004502172583964",
    s: "257938146813645729694127385541896273738452691926371458465219837389764512172583964",
    d: -20967,
  },
  {
    p: "258070460070041280014268305080715030700000104030426800007004010500102098390087542",
    s: "258379461673541289914268375482715936765893124139426857827954613546132798391687542",
    d: -20967,
  },
  {
    p: "008014063000580120961732058080007900617090284429860007002008345805403691000000000",
    s: "258914763734586129961732458583247916617395284429861537192678345875423691346159872",
    d: -20979,
  },
  {
    p: "050903164060081200004652007500390040306700802901264305405830719800140526600000000",
    s: "258973164769481253134652987572398641346715892981264375425836719893147526617529438",
    d: -20979,
  },
  {
    p: "209800340017000006000100507600702400004081032782040169400063000920418073163957284",
    s: "259876341317524896846139527631792458594681732782345169478263915925418673163957284",
    d: -20967,
  },
  {
    p: "200030897700281306358967140817400235000750000930002674103620000480000003002000761",
    s: "261534897749281356358967142817496235624753918935812674173625489486179523592348761",
    d: -20979,
  },
  {
    p: "260000083090008027807265194070080000523070009486013000009000248040120970052849361",
    s: "264791583195438627837265194971582436523674819486913752619357248348126975752849361",
    d: -20979,
  },
  {
    p: "000007508750480030003000047010670052326500109580001364042365780608019005170824003",
    s: "264937518751482936893156247419673852326548179587291364942365781638719425175824693",
    d: -20967,
  },
  {
    p: "065100907100785462807069513000314706630007008000826051000431000300050670429678000",
    s: "265143987193785462847269513582314796631597248974826351756431829318952674429678135",
    d: -20967,
  },
  {
    p: "267401000103580206598263400020009604081046000670000931800000025439125008752600000",
    s: "267491853143587296598263417325719684981346572674852931816974325439125768752638149",
    d: -20979,
  },
  {
    p: "060009400305780602400603500804075016530068720796102054603250008900307005157090000",
    s: "268519437315784692479623581824975316531468729796132854643251978982347165157896243",
    d: -20979,
  },
  {
    p: "269184307800200019000593080590600074640025831120740900050002790004000003902350146",
    s: "269184357835276419471593682598631274647925831123748965356412798714869523982357146",
    d: -20967,
  },
  {
    p: "270493050040500002358016047530087061007042503684001070000020000400030820725869134",
    s: "271493658946578312358216947532987461197642583684351279863124795419735826725869134",
    d: -20967,
  },
  {
    p: "273846195000201867000000040000060400347582019681490200034718000010029000820650731",
    s: "273846195495231867168975342952163478347582619681497253534718926716329584829654731",
    d: -20967,
  },
  {
    p: "004516009000920701090008260012600058936080017750000632589362174041700000000001596",
    s: "274516389865923741193478265412637958936285417758194632589362174641759823327841596",
    d: -20979,
  },
  {
    p: "205080060098542071103700050056000180001058703807120605089010530010065800502873019",
    s: "275381964698542371143796258956437182421658793837129645789214536314965827562873419",
    d: -20967,
  },
  {
    p: "000519030000008501185320000007001289821907304040003160703090605408730900952140870",
    s: "276519438394678521185324796637451289821967354549283167713892645468735912952146873",
    d: -20979,
  },
  {
    p: "270051340304020501015003080792004860000890004080006005820065039140072608530089127",
    s: "278951346364728591915643782792514863653897214481236975827165439149372658536489127",
    d: -20967,
  },
  {
    p: "279050083000817592005200400000600341300104908008000600864023700730968050592741036",
    s: "279456183643817592185239467927685341356174928418392675864523719731968254592741836",
    d: -20967,
  },
  {
    p: "079500406050024709403600025812000907960870342040260001138906070020103090000702613",
    s: "279518436651324789483697125812435967965871342347269851138956274726143598594782613",
    d: -20967,
  },
  {
    p: "281007040500000061030904050004170020720090000165400978000741000072839615813265497",
    s: "281657349549382761637914852394178526728596134165423978956741283472839615813265497",
    d: -20967,
  },
  {
    p: "280497136900603800463105209140902305000001790397006012700200600004518007802709000",
    s: "285497136971623854463185279148972365526341798397856412759234681634518927812769543",
    d: -20967,
  },
  {
    p: "285704691006152873037006502060091705040020310010000000901348056650217430000000087",
    s: "285734691496152873137986542863491725749625318512873964971348256658217439324569187",
    d: -20967,
  },
  {
    p: "200930007000060083631805004003080720520300809840527300710603958098152476056000000",
    s: "285934617974261583631875294163489725527316849849527361712643958398152476456798132",
    d: -20979,
  },
  {
    p: "286009010005000236014670850658030940109460000740005068092006307001790425007080691",
    s: "286359714975841236314672859658137942129468573743925168492516387861793425537284691",
    d: -20967,
  },
  {
    p: "280510000531002468970000015457000006608007043000608752710286504360070801800931000",
    s: "286514379531792468974863215457329186628157943193648752719286534362475891845931627",
    d: -20979,
  },
  {
    p: "207360100160400072049071000008047300402183697000002001005804013394710058000539764",
    s: "287365149163498572549271836918647325452183697736952481675824913394716258821539764",
    d: -20967,
  },
  {
    p: "209640007000000080601857924028003491010428060040910802005200019400170058160589740",
    s: "289641537754392186631857924528763491917428365346915872875234619493176258162589743",
    d: -20967,
  },
  {
    p: "280740361574160800613090700000080207965037008008910000890471506156028074307000000",
    s: "289745361574163829613892745431586297965237418728914653892471536156328974347659182",
    d: -20967,
  },
  {
    p: "203040605000092003701350900060589370800000560352617498410870209507000000920403057",
    s: "293748615645192783781356924164589372879234561352617498416875239537921846928463157",
    d: -20979,
  },
  {
    p: "204073005500286943600940127080060000956301078402850369027008090165790002000030000",
    s: "294173685571286943638945127783469251956321478412857369327618594165794832849532716",
    d: -20979,
  },
  {
    p: "204560010183920000060183000752000109830259604009871305310702956475608200000000000",
    s: "294567813183924567567183492752436189831259674649871325318742956475698231926315748",
    d: -20979,
  },
  {
    p: "095000604164752080087004215612085000050007468078369102000008300040000006039216547",
    s: "295831674164752983387694215612485739953127468478369152726548391541973826839216547",
    d: -20967,
  },
  {
    p: "096803050785000346043750800078290614409078000500130098634510080950382000001000500",
    s: "296843157785921346143756829378295614419678235562134798634517982957382461821469573",
    d: -20979,
  },
  {
    p: "097540130503002800000030925106309000849600300372050000080006003600085279724193568",
    s: "297548136513962847468731925156329784849617352372854691985276413631485279724193568",
    d: -20979,
  },
  {
    p: "207861000810374009400020700024916000178200000500007123043700512980002374000143690",
    s: "297861435815374269436529781324916857178235946569487123643798512981652374752143698",
    d: -20979,
  },
  {
    p: "310700080006421935945360172100047029789002054264080703401500200008200000000096300",
    s: "312759486876421935945368172153647829789132654264985713491573268638214597527896341",
    d: -20979,
  },
  {
    p: "314928507000040902900063841050206000061890005003057008800672410079405203102389000",
    s: "314928567586741932927563841758236194261894375493157628835672419679415283142389756",
    d: -20967,
  },
  {
    p: "305200000008001345074563080703426508250318490081095620009807030000030901500009806",
    s: "315284769628971345974563182793426518256318497481795623169857234847632951532149876",
    d: -20979,
  },
  {
    p: "006295407870000501490807302043650000700009250000000600601023740034008126257461938",
    s: "316295487872346591495817362143652879768139254529784613681923745934578126257461938",
    d: -20967,
  },
  {
    p: "316020497584709002007603851240061705678000029009000040800300910095000070701402568",
    s: "316825497584719632927643851243961785678534129159278346862357914495186273731492568",
    d: -20967,
  },
  {
    p: "310029050907306008820157936105008090209675003743010000690004300570090860030700529",
    s: "316829457957346218824157936165438792289675143743912685692584371571293864438761529",
    d: -20967,
  },
  {
    p: "310904850050010200002580000200000403480005061670049080734108620020456738568730094",
    s: "316924857857613249942587316295861473483275961671349582734198625129456738568732194",
    d: -20967,
  },
  {
    p: "010952000045301926002608501700500890600800314280103760463719200007005600508006109",
    s: "316952487845371926972648531731564892659827314284193765463719258197285643528436179",
    d: -20967,
  },
  {
    p: "310900500009057630000630981203501740047000015601748000130005269700429153592000400",
    s: "316984527829157634475632981283591746947263815651748392134875269768429153592316478",
    d: -20967,
  },
  {
    p: "307098046420073098589000307005861000643900000801002650060085910958106030034720000",
    s: "317298546426573198589614327295861473643957281871432659762385914958146732134729865",
    d: -20979,
  },
  {
    p: "007486920008910073004700100006371502509000001132508047000630208291857364000102000",
    s: "317486925628915473954723186486371592579264831132598647745639218291857364863142759",
    d: -20979,
  },
  {
    p: "318005092042000070079000048100937205897250014000408760720004001053071006001023957",
    s: "318745692642189573579362148164937285897256314235418769726594831953871426481623957",
    d: -20979,
  },
  {
    p: "310027540856043027274100030001006802082509001547201003028054060403098000000002304",
    s: "319827546856943127274165938931476852682539471547281693128354769463798215795612384",
    d: -20979,
  },
  {
    p: "326104700004000916159876004001705003238001057007203168070018039845309070010000000",
    s: "326194785784532916159876324461785293238961457597243168672418539845329671913657842",
    d: -20979,
  },
  {
    p: "326490017010300490079010360008000700230069048054080026500820609702604580003051074",
    s: "326495817815376492479218365968142753237569148154783926541827639792634581683951274",
    d: -20979,
  },
  {
    p: "300500000400067200709410000160040098040008310002090706290704681674831920518926400",
    s: "326589174481367259759412863167243598945678312832195746293754681674831925518926437",
    d: -20979,
  },
  {
    p: "320070009070090008809205706060108970085407002200956003052341090734580621190060300",
    s: "326874519571693248849215736463128975985437162217956483652341897734589621198762354",
    d: -20967,
  },
  {
    p: "007001004086205300401000062069802003035700000842913076094106738603098401018430600",
    s: "327681954986245317451379862769852143135764289842913576594126738673598421218437695",
    d: -20967,
  },
  {
    p: "000025879507300001006710050000207905019458006602190700974500620235000197068900543",
    s: "341625879527389461896714352483267915719458236652193784974531628235846197168972543",
    d: -20967,
  },
  {
    p: "340579000870001090510030470068100240231706509054083010025007004497000058083050120",
    s: "342579861876421395519638472768195243231746589954283716125867934497312658683954127",
    d: -20979,
  },
  {
    p: "000005170000736000060214390600103785705680403813500962200051009450070800100468527",
    s: "342895176981736254567214398694123785725689413813547962278351649456972831139468527",
    d: -20967,
  },
  {
    p: "046100028910003000850609001620004190501090080094510632080002740000985210069471853",
    s: "346157928917823564852649371628734195531296487794518632185362749473985216269471853",
    d: -20967,
  },
  {
    p: "346701928291060375080902010060370042403008060902506180009000030500280400004690051",
    s: "346751928291864375785932614168379542453128769972546183629415837517283496834697251",
    d: -20979,
  },
  {
    p: "340028015270006489005017000709043526400200807000000300628050900954082103130094208",
    s: "346928715271536489895417632789143526413265897562879341628351974954782163137694258",
    d: -20979,
  },
  {
    p: "040070005507001036600350420003984061204103070001025390486000150000538040935400782",
    s: "349672815527841936618359427753984261294163578861725394486297153172538649935416782",
    d: -20979,
  },
  {
    p: "351009684004068005068340002037001000910086073085790021000004009109850040506932817",
    s: "351279684294168735768345192437521968912486573685793421873614259129857346546932817",
    d: -20967,
  },
  {
    p: "350870609670200105000156374008002906246030801000610240567320490102080560083060000",
    s: "351874629674293185829156374718542936246739851935618247567321498192487563483965712",
    d: -20967,
  },
  {
    p: "002000189087100406140039502839006014010000000000301807503610000621048095078953621",
    s: "352467189987125436146839572839576214715284963264391857593612748621748395478953621",
    d: -20979,
  },
  {
    p: "302014096840600035916053842000400000400060300500397068234576000080931070170200653",
    s: "352814796847629135916753842763482519498165327521397468234576981685931274179248653",
    d: -20967,
  },
  {
    p: "304018070800000031961570420738169204410000009200000183009840312002000640140627800",
    s: "354218976827496531961573428738169254415382769296754183679845312582931647143627895",
    d: -20979,
  },
  {
    p: "350070920061825740802093100000100234403089060006700091130008470007900305005317680",
    s: "354671928961825743872493156798156234413289567526734891139568472687942315245317689",
    d: -20979,
  },
  {
    p: "359024700600008000048600051510380400070451086834067125067803500490010032080200607",
    s: "359124768621578943748639251516382479972451386834967125267893514495716832183245697",
    d: -20967,
  },
  {
    p: "350024086004080009081965000078206935020009800900030061017058000092300604036492178",
    s: "359124786264783519781965423178246935623519847945837261417658392892371654536492178",
    d: -20979,
  },
  {
    p: "350200806400659307000080500030140079790306054240070603910500708020800931863791400",
    s: "359217846482659317176483592635148279798326154241975683914532768527864931863791425",
    d: -20967,
  },
  {
    p: "309400720120090000748003650864031000013625040502840103095170430280354000000080510",
    s: "359468721126597384748213659864731295913625847572849163695172438281354976437986512",
    d: -20979,
  },
  {
    p: "059708024407092000260035807594080012872010930013000500900821000030900000028357469",
    s: "359768124487192653261435897594683712872514936613279548946821375735946281128357469",
    d: -20979,
  },
  {
    p: "359847026607900304041050708030000000064708912702000835095364200420071009070200043",
    s: "359847126687912354241653798938125467564738912712496835895364271423571689176289543",
    d: -20967,
  },
  {
    p: "000040050004215036925603841090000560718006403600720180006000010137482690280500074",
    s: "361849752874215936925673841492138567718956423653724189546397218137482695289561374",
    d: -20979,
  },
  {
    p: "360925874005070603402836050008302000106090008723140069087019000200054106504600002",
    s: "361925874895471623472836951958362417146597238723148569687219345239754186514683792",
    d: -20979,
  },
  {
    p: "002009500000800702080650010839000000015300028274100030008061203126973845593240671",
    s: "362719584951834762487652319839426157615397428274185936748561293126973845593248671",
    d: -20979,
  },
  {
    p: "360000170008702300075061000056839002824615703130400658200040930003178260041003007",
    s: "362984175918752346475361829756839412824615793139427658287546931593178264641293587",
    d: -20967,
  },
  {
    p: "000107042910024007274080051090001405740850130053640080020413598501960204089200000",
    s: "365197842918524367274386951896731425742859136153642789627413598531968274489275613",
    d: -20967,
  },
  {
    p: "367120490900407080504603000600280030103546208842371900019034060200010840450900000",
    s: "367128495921457683584693721675289134193546278842371956719834562236715849458962317",
    d: -20979,
  },
  {
    p: "301005004240006590965040003030429007104700980597601400783012049052034008009807005",
    s: "371295864248376591965148273836429157124753986597681432783512649652934718419867325",
    d: -20967,
  },
  {
    p: "000491050009365040465002109530018402201903000090500803653080900040009506908054371",
    s: "372491658819365247465872139536718492281943765794526813653187924147239586928654371",
    d: -20979,
  },
  {
    p: "302540160010286375608010040590460831400070590000030004701650902240800003860320400",
    s: "372549168914286375658713249597462831423178596186935724731654982245897613869321457",
    d: -20979,
  },
  {
    p: "370520691908003502502009037801056329693080010700391060280040070000067200000132980",
    s: "374528691918673542562419837841756329693284715725391468286945173139867254457132986",
    d: -20967,
  },
  {
    p: "305009400049720683260314059900008560750402038813507024082901376037240000000000000",
    s: "375689412149725683268314759924138567756492138813567924482951376537246891691873245",
    d: -20967,
  },
  {
    p: "300005829802630000000009360200504080705921600164803090047052918008190073913040050",
    s: "376415829892637145451289367239564781785921634164873592647352918528196473913748256",
    d: -20979,
  },
  {
    p: "370009050120003900004080702602918500000304081041257396000072609206105073719436000",
    s: "378629154125743968964581732632918547597364281841257396453872619286195473719436825",
    d: -20967,
  },
  {
    p: "078050900049000360260079400004021685890405710005080209080230504956140800400598070",
    s: "378654921549812367261379458734921685892465713615783249187236594956147832423598176",
    d: -20979,
  },
  {
    p: "070106024006300501510287006408702000052469100961038042090803210000620398803901000",
    s: "379156824286394571514287936438712659752469183961538742695843217147625398823971465",
    d: -20967,
  },
  {
    p: "379500002502300800100692000600470000030059100090068023007000264410026785286745931",
    s: "379584612562317849148692357621473598834259176795168423957831264413926785286745931",
    d: -20979,
  },
  {
    p: "309010500040798061000350209804900602762140003053826714631400920598001000007039000",
    s: "379612548245798361186354279814973652762145893953826714631487925598261437427539186",
    d: -20967,
  },
  {
    p: "001000900067804230904000658035002009709006423642000815208470006196328040470059080",
    s: "381265974567894231924713658835142769719586423642937815258471396196328547473659182",
    d: -20967,
  },
  {
    p: "081600040560100920009030600050308269073940080096210070000053000600890731938761452",
    s: "381629547567184923429537618154378269273946185896215374712453896645892731938761452",
    d: -20979,
  },
  {
    p: "082706945014300002006249080891500234600400098005900006069802403008000020027653819",
    s: "382716945914385762756249381891567234673421598245938176169872453538194627427653819",
    d: -20967,
  },
  {
    p: "086290075075000400012753800521007084869345000003020560007032600030576001654800003",
    s: "386294175975681432412753896521967384869345217743128569197432658238576941654819723",
    d: -20979,
  },
  {
    p: "387620049125098000409013805004270698910050073078049200796180502200000086000000004",
    s: "387625149125498367469713825534271698912856473678349251796184532241537986853962714",
    d: -20979,
  },
  {
    p: "080152647070800000001430200895300720734928001100040983240510000010270300900683412",
    s: "389152647472896135561437298895361724734928561126745983243519876618274359957683412",
    d: -20967,
  },
  {
    p: "391802600060310090487690300050083026003050148718200953800000060079406001146908007",
    s: "391842675265317894487695312954183726623759148718264953832571469579436281146928537",
    d: -20967,
  },
  {
    p: "302567401086094350000180920000750069260009000709026034920608705071345892500000000",
    s: "392567481186294357457183926834751269265439178719826534923618745671345892548972613",
    d: -20979,
  },
  {
    p: "090000000012609057700040093160023500500986204008005030045010086000794325237568941",
    s: "394857162812639457756241893169423578573986214428175639945312786681794325237568941",
    d: -20979,
  },
  {
    p: "390080270002930060060512309580269134010070600036140097624800750001053420050700000",
    s: "395486271142937865768512349587269134419375682236148597624891753971653428853724916",
    d: -20979,
  },
  {
    p: "090017428120000006460000719513084697689100203000090580702001000000430172800762905",
    s: "395617428127849356468523719513284697689175243274396581732951864956438172841762935",
    d: -20979,
  },
  {
    p: "306104257070035010450970630700000900810390062500801304120759806040208003080000125",
    s: "396184257278635419451972638732546981814397562569821374123759846645218793987463125",
    d: -20979,
  },
  {
    p: "096000080812007436040060020578120640400600819109000750034050108601703000987201365",
    s: "396412587812597436745368921578129643423675819169834752234956178651783294987241365",
    d: -20967,
  },
  {
    p: "307506008060870300000403079708694000920307564430200007573960000140008256680140790",
    s: "397516428264879315815423679758694132921387564436251987573962841149738256682145793",
    d: -20967,
  },
  {
    p: "307018002510970830208403190050007204940005603003246915480009000709000428000004769",
    s: "397618542514972836268453197651397284942185673873246915486729351739561428125834769",
    d: -20979,
  },
  {
    p: "390052104428701030065000702010206309600045007002379016200017590570928000900034270",
    s: "397852164428761935165493782714286359639145827852379416243617598571928643986534271",
    d: -20967,
  },
  {
    p: "098004502246085931007000840001059067604030109900106380003570298005003610109468000",
    s: "398614572246785931517392846831259467654837129972146385463571298785923614129468753",
    d: -20967,
  },
  {
    p: "090620100450013060201500480070052034032400705605097200004000070000705341783941526",
    s: "398624157457813962261579483879152634132468795645397218514236879926785341783941526",
    d: -20979,
  },
  {
    p: "410005700036001042987342050040200009078100204009437010054803920020590001891020430",
    s: "412685793536971842987342156145268379378159264269437518654813927723594681891726435",
    d: -20979,
  },
  {
    p: "412739065600508210905000037200004593193605784004000020040070652000486071761200000",
    s: "412739865637548219985162437276814593193625784854397126348971652529486371761253948",
    d: -20967,
  },
  {
    p: "003067008597824061020090400040158723100470609002930514961745032070209000000000047",
    s: "413567298597824361826391475649158723135472689782936514961745832374289156258613947",
    d: -20967,
  },
  {
    p: "400206980900040035000095600007400850052309400064587002079104068031908524508603700",
    s: "415236987986741235723895641197462853852319476364587192279154368631978524548623719",
    d: -20979,
  },
  {
    p: "006700930530129007072406080703004521085207040264513000020641000041058200859302000",
    s: "416785932538129467972436185793864521185297346264513798327641859641958273859372614",
    d: -20967,
  },
  {
    p: "410397256972016038005080009704001693536409081080600000803000912250000007607000045",
    s: "418397256972516438365284179724851693536429781189673524843765912251948367697132845",
    d: -20979,
  },
  {
    p: "410308276070619580008700000807060150103597000500183940700000025005400000234875691",
    s: "419358276372619584658742319897264153143597862526183947781936425965421738234875691",
    d: -20979,
  },
  {
    p: "009086200203019406607300509374008025060103078890075304008052701040807692706000000",
    s: "419586237253719486687324519374968125562143978891275364938652741145837692726491853",
    d: -20979,
  },
  {
    p: "400006908700500642089472153078154300390200504000830210950040000037605409060901005",
    s: "425316978713598642689472153278154396391267584546839217952743861137685429864921735",
    d: -20979,
  },
  {
    p: "005068701001409050938150642380542079200900000090876235509700326643205900800000000",
    s: "425368791761429853938157642386542179257931468194876235519784326643215987872693514",
    d: -20967,
  },
  {
    p: "420039708800046012150080046360850290001024007070360000235010479009405800700090165",
    s: "426139758897546312153782946364857291581924637972361584235618479619475823748293165",
    d: -20979,
  },
  {
    p: "420970513030451062007632090783200000500703084609015200000004309394587620070300000",
    s: "426978513938451762157632498783249156512763984649815237865124379394587621271396845",
    d: -20979,
  },
  {
    p: "007130689083069712069008030631007200840300060972004050090076105210503406706201000",
    s: "427135689583469712169728534631957248845312967972684351394876125218593476756241893",
    d: -20967,
  },
  {
    p: "420000183530801062000402750102046008368090201970120500003604020000983017681200090",
    s: "427569183539871462816432759152346978368795241974128536793614825245983617681257394",
    d: -20979,
  },
  {
    p: "400006057510847206607502800006085130182003504300000608234068905000300782000129460",
    s: "428916357513847296697532841746285139182693574359471628234768915961354782875129463",
    d: -20967,
  },
  {
    p: "420000760710004038000267000060071504247359186850002973000920607375010090690700301",
    s: "429138765716594238538267419963871524247359186851642973184923657375416892692785341",
    d: -20967,
  },
  {
    p: "409150736000204158080736092014089203268403015903520084002000000300000067847900000",
    s: "429158736736294158185736492514689273268473915973521684652317849391842567847965321",
    d: -20979,
  },
  {
    p: "030610890000078240710200030040853179891020350357900602600000715104500900905107420",
    s: "432615897569378241718294536246853179891726354357941682623489715174532968985167423",
    d: -20967,
  },
  {
    p: "430287150002630008701540602000028060600904301800376000954702003003800270278413500",
    s: "436287159592631748781549632345128967627954381819376425954762813163895274278413596",
    d: -20967,
  },
  {
    p: "030089010105347800908510070670105008301000427000000051000850763046031080783690145",
    s: "437289516165347892928516374674125938351968427892473651219854763546731289783692145",
    d: -20979,
  },
  {
    p: "430001000056090301921070085080000164769018253510362098008130546003840912000000000",
    s: "437581629856294371921673485382759164769418253514362798298137546673845912145926837",
    d: -20979,
  },
  {
    p: "438570602901836045050904800804195020510082000200643018390000180647210903000009000",
    s: "438571692921836745756924831864195327513782469279643518392457186647218953185369274",
    d: -20967,
  },
  {
    p: "430206001082030040605409083850060304306750120000300005500917432174820560903000807",
    s: "439286751782531946615479283857162394396754128241398675568917432174823569923645817",
    d: -20967,
  },
  {
    p: "030610057570008192100759640304285000067030524295406081640027935053890000000000000",
    s: "439612857576348192182759643314285769867931524295476381648127935753894216921563478",
    d: -20967,
  },
  {
    p: "400000708020091056907005001000002183803069005100083960789634512214958637630000000",
    s: "451326798328791456967845321596472183843169275172583964789634512214958637635217849",
    d: -20967,
  },
  {
    p: "450070000608000400030045708002016945067294103004000267890157024740862591105000000",
    s: "451978632678321459239645718382716945567294183914583267896157324743862591125439876",
    d: -20979,
  },
  {
    p: "002093600319705002706000003530900004128347050600502370040239060001070235270651840",
    s: "452893617319765482786124593537986124128347956694512378845239761961478235273651849",
    d: -20967,
  },
  {
    p: "400037861781642003906580720608314592100809300005206048003495010507028030000000000",
    s: "452937861781642953936581724678314592124859376395276148863495217547128639219763485",
    d: -20967,
  },
  {
    p: "453600008608042001910070064064009000291087356030010009006708195000904607009165423",
    s: "453691278678542931912873564864359712291487356537216849346728195125934687789165423",
    d: -20967,
  },
  {
    p: "453080900100024057792531060500109000010200500000075619367000100000012780821697435",
    s: "453786921186924357792531864578169243619243578234875619367458192945312786821697435",
    d: -20979,
  },
  {
    p: "006009003091870004738654120309540800805301900000098070682905037043000691917400000",
    s: "456129783291873564738654129329547816875361942164298375682915437543782691917436258",
    d: -20979,
  },
  {
    p: "056178000090025714127043080289300400014080062065400008971064203602050001000200697",
    s: "456178329893625714127943586289316475314587962765492138971864253632759841548231697",
    d: -20967,
  },
  {
    p: "406100030709052064820030050075080326068700001090610800902068000503047609607391582",
    s: "456179238739852164821436957175984326368725491294613875912568743583247619647391582",
    d: -20967,
  },
  {
    p: "456390802080100790710042603000030205504070960062000080000000420020461039645923178",
    s: "456397812283156794719842653178639245534278961962514387391785426827461539645923178",
    d: -20979,
  },
  {
    p: "000010609268974501139620004040509176000702403005401802003000048784290300000048267",
    s: "457813629268974531139625784842539176916782453375461892623157948784296315591348267",
    d: -20967,
  },
  {
    p: "061285030870163402000009080090814075107600308608500290780046013910000024004720060",
    s: "461285937879163452325479186293814675157692348648537291782946513916358724534721869",
    d: -20979,
  },
  {
    p: "002850390089470210001926004307095428005740900040032605000210009290007103050389042",
    s: "462851397589473216731926854317695428625748931948132675873214569294567183156389742",
    d: -20967,
  },
  {
    p: "000125009080034210001087460800746500076051920100093607600000398509308740008469002",
    s: "463125879987634215251987463892746531376851924145293687614572398529318746738469152",
    d: -20979,
  },
  {
    p: "463007501750063000180540730524930008008074210017250093295716300840320107000000000",
    s: "463897521752163849189542736524931678938674215617258493295716384846329157371485962",
    d: -20967,
  },
  {
    p: "005070890928014070100000426802731000547000012600452987250000738710385000000007145",
    s: "465273891928614573173598426892731654547869312631452987259146738714385269386927145",
    d: -20979,
  },
  {
    p: "060805013910600028082091746030502087700963451604708009305406100040007000800059004",
    s: "467825913913674528582391746139542687728963451654718239395486172246137895871259364",
    d: -20979,
  },
  {
    p: "400002009721904850009070642230601490904725061007000005090047510500803004140096730",
    s: "468352179721964853359178642235681497984725361617439285893247516576813924142596738",
    d: -20979,
  },
  {
    p: "070509000528003097096001542009000063630090800710380000850007014900218635160430978",
    s: "471529386528643197396871542289154763634792851715386429853967214947218635162435978",
    d: -20979,
  },
  {
    p: "071609203380240090295087600030500864062074130140900072620430018910008000003190000",
    s: "471659283386241795295387641739512864562874139148963572627435918914728356853196427",
    d: -20979,
  },
  {
    p: "072000083059078001168240905910580027583020160247301059030006702600709000005000016",
    s: "472195683359678241168243975916584327583927164247361859831456792624719538795832416",
    d: -20979,
  },
  {
    p: "473618090158290007020050184801063752030475061705800903500046370617009400000000000",
    s: "473618295158294637926357184841963752239475861765821943582146379617539428394782516",
    d: -20967,
  },
  {
    p: "073000951081000460600401032567009080002804176010760295040930028320006049790240500",
    s: "473682951281395467659471832567129384932854176814763295145937628328516749796248513",
    d: -20967,
  },
  {
    p: "075020030009005806106007450050000261600302790900461503701896025090513047003270018",
    s: "475628139239145876186937452354789261618352794927461583741896325892513647563274918",
    d: -20967,
  },
  {
    p: "470100000619800003302907816521793004806420001030610290247300560060009030003064007",
    s: "478136952619852743352947816521793684896425371734618295247381569165279438983564127",
    d: -20979,
  },
  {
    p: "078050200013420500200018734850100642340095187120864950700630015000080000000042879",
    s: "478356291913427568265918734859173642346295187127864953782639415594781326631542879",
    d: -20967,
  },
  {
    p: "478510320300790008500430601840057002250100830010080945004605013027000580635800704",
    s: "478516329361792458592438671843957162259164837716283945984675213127349586635821794",
    d: -20967,
  },
  {
    p: "082310960500792483000400021040209600605043702907001004854106209000900000006527348",
    s: "482315967561792483739468521348279615615843792927651834854136279273984156196527348",
    d: -20979,
  },
  {
    p: "480006920702803506609024003106508030007910065020007091001005000005600304834271659",
    s: "483156927712893546659724183196548732347912865528367491961435278275689314834271659",
    d: -20979,
  },
  {
    p: "086120370305008060971056002700000039560070010839504620047080293003001780000037154",
    s: "486129375325748961971356842714862539562973418839514627147685293253491786698237154",
    d: -20979,
  },
  {
    p: "000009050603017900102005473900751028205080000078902501729038000561290837800076005",
    s: "487329156653417982192865473946751328215683749378942561729538614561294837834176295",
    d: -20979,
  },
  {
    p: "480010600162090504935046700800001076071684905624975080796002801510869200000000000",
    s: "487513692162798534935246718859321476371684925624975183796432851513869247248157369",
    d: -20967,
  },
  {
    p: "400030961500790084193648075058109000031820006720300108005083007306450829809010000",
    s: "487532961562791384193648275658179432931824756724365198245983617316457829879216543",
    d: -20967,
  },
  {
    p: "401708325500020640680453091000309004005200030238000100309170482007094003850632900",
    s: "491768325573921648682453791716389254945217836238546179369175482127894563854632917",
    d: -20979,
  },
  {
    p: "003152700108400350050083040709831504004607008001009203940300607316074095007905430",
    s: "493152786178496352652783149729831564534627918861549273945318627316274895287965431",
    d: -20967,
  },
  {
    p: "090006001062000453050413006618004007040062819729085060280090645000008002006241938",
    s: "493526781162879453857413296618934527345762819729185364281397645934658172576241938",
    d: -20979,
  },
  {
    p: "003000027500210006621030850004080000850403912709105468102597604947360285305000000",
    s: "493658127578219346621734859214986573856473912739125468182597634947361285365842791",
    d: -20967,
  },
  {
    p: "090017003200538400860090070000384257002901648748260300034800706020150980000740032",
    s: "495617823271538469863492175916384257352971648748265391534829716627153984189746532",
    d: -20979,
  },
  {
    p: "096000107207310864380760005603540920870000050905832601060400719709105300030070002",
    s: "496258137257319864381764295613547928872691453945832671568423719729185346134976582",
    d: -20979,
  },
  {
    p: "096300008087004592025807064261483007053000000070501603732640010540008000018739200",
    s: "496352178387164592125897364261483957853976421974521683732645819549218736618739245",
    d: -20979,
  },
  {
    p: "098260100007831090510740002030610800076458301001900005750396010180004036009180057",
    s: "498265173627831594513749682235617849976458321841923765754396218182574936369182457",
    d: -20979,
  },
  {
    p: "098017502375604010600809734069548073030000985502790106050470608810035420000000000",
    s: "498317562375624819621859734169548273734162985582793146253471698816935427947286351",
    d: -20967,
  },
  {
    p: "513020960002630100000810205007302001300004602120768094031000009059280710276941850",
    s: "513427968982635147764819235647392581398154672125768394831576429459283716276941853",
    d: -20967,
  },
  {
    p: "014809370003076005876045100002498751701203804450617203000001940105900600680000000",
    s: "514829376923176485876345129362498751791253864458617293237561948145982637689734512",
    d: -20979,
  },
  {
    p: "016200087008570490790108500007412638062050714300800200120000076085701903479000020",
    s: "516294387238576491794138562957412638862359714341867259123945876685721943479683125",
    d: -20979,
  },
  {
    p: "508207490497580000632491870020170006804300000100640250200000030780904520351706904",
    s: "518267493497583162632491875925178346864352719173649258249815637786934521351726984",
    d: -20967,
  },
  {
    p: "000024007060900004947865203006002480020008360034609025203190548601053970409007106",
    s: "518324697362971854947865213796532481125748369834619725273196548681453972459287136",
    d: -20967,
  },
  {
    p: "510600307076580004049701080031004056050378491490156030785200000063090800020800063",
    s: "518649327376582914249731685831924756652378491497156238785263149163495872924817563",
    d: -20979,
  },
  {
    p: "018923640070800300090100502107090038480001950209058174905730861836410700001000000",
    s: "518923647672845319394167582157694238483271956269358174945732861836419725721586493",
    d: -20979,
  },
  {
    p: "021098746783100209694705803150432008908057100072081500009064000437000620060000000",
    s: "521398746783146259694725813156432978948657132372981564219564387437819625865273491",
    d: -20979,
  },
  {
    p: "500009704000240600069837500000000105000001468602084070856312940290756831731498000",
    s: "523169784187245693469837512948673125375921468612584379856312947294756831731498256",
    d: -20967,
  },
  {
    p: "020910846080003092016004357231096005069008234045730001094200073350009000008000529",
    s: "523917846487563192916824357231496785769158234845732961194285673352679418678341529",
    d: -20979,
  },
  {
    p: "500308746673029081108700030080093005907580004210004390001936007700052013002047059",
    s: "529318746673429581148765932486293175937581264215674398851936427794852613362147859",
    d: -20967,
  },
  {
    p: "000004070702361095900000003003000200090120807428790300310470008047530961259816734",
    s: "531984672782361495964257183173648259695123847428795316316479528847532961259816734",
    d: -20979,
  },
  {
    p: "000070004400006000017452639050090860102047095008635102601903058983010006205768910",
    s: "536179284429386571817452639354291867162847395798635142671923458983514726245768913",
    d: -20967,
  },
  {
    p: "037060010980000000421080079600500003800000241170040590064902150395718402208456930",
    s: "537269814986174325421385679649521783853697241172843596764932158395718462218456937",
    d: -20979,
  },
  {
    p: "500070024901600007400830090182060970396507208705920006074201803200006419810340000",
    s: "538179624921654387467832591182463975396517248745928136674291853253786419819345762",
    d: -20979,
  },
  {
    p: "538410706496003512000059384625030901789500000300297065003040000800326009210070030",
    s: "538412796496783512172659384625834971789561423341297865963148257857326149214975638",
    d: -20967,
  },
  {
    p: "508904627047060509901250048400670980000832050080540036000705091015006000700123865",
    s: "538914627247368519961257348453671982679832154182549736326785491815496273794123865",
    d: -20967,
  },
  {
    p: "540209860098601250627080000975126008416058970003497600130005024064710530000000000",
    s: "541279863398641257627583491975126348416358972283497615139865724864712539752934186",
    d: -20967,
  },
  {
    p: "502060098000200340073108650006410839800602400000030706780900560000571204425386971",
    s: "542763198618259347973148652256417839837692415194835726781924563369571284425386971",
    d: -20967,
  },
  {
    p: "543009060092540038106003400000905086360800000820300940000751000204698713017432859",
    s: "543189267792546138186273495471925386369814572825367941938751624254698713617432859",
    d: -20967,
  },
  {
    p: "046207900120605740837914062000341680000008027058006100405000019080152406260470800",
    s: "546287931129635748837914562792341685614598327358726194475863219983152476261479853",
    d: -20967,
  },
  {
    p: "540002780097816345380470926962030007005649810008527090154080209600000130800000000",
    s: "546392781297816345381475926962138457735649812418527693154783269679254138823961574",
    d: -20967,
  },
  {
    p: "000163280600000710300209000075321804820046905430590172260037450000652097050910000",
    s: "547163289692485713318279546975321864821746935436598172269837451184652397753914628",
    d: -20979,
  },
  {
    p: "007260018263981054008745300910430075674009800830100400009050180086010040000004267",
    s: "547263918263981754198745326912438675674529831835176492429657183786312549351894267",
    d: -20979,
  },
  {
    p: "008230760100576802206840359960728530000600190053910600327005006614302900005000200",
    s: "548239761139576842276841359961728534482653197753914628327195486614382975895467213",
    d: -20967,
  },
  {
    p: "540270609700691805600000072965032107204706000001958406096000530837000000150009764",
    s: "548273619723691845619845372965432187284716953371958426496127538837564291152389764",
    d: -20979,
  },
  {
    p: "508007290100000007006140350007806519201970004000014000900480136004602975365791842",
    s: "548367291193258467726149358437826519251973684689514723972485136814632975365791842",
    d: -20967,
  },
  {
    p: "009070010070145096681009750028904600903062471000750089000481967190300548800007003",
    s: "549678312372145896681239754728914635953862471416753289235481967197326548864597123",
    d: -20967,
  },
  {
    p: "049800132603000780700034050324750690801060420006200503200087000000010209167329845",
    s: "549876132613592784782134956324751698851963427976248513295487361438615279167329845",
    d: -20979,
  },
  {
    p: "061429783480070190009180005048012659000050407190000308803005902600297031920030004",
    s: "561429783482573196379186245748312659236958417195764328813645972654297831927831564",
    d: -20967,
  },
  {
    p: "560704009040069810008300060402050003000003402630070081050907230009236045324815796",
    s: "561784329243569817978321564492158673817693452635472981156947238789236145324815796",
    d: -20979,
  },
  {
    p: "062000407907650280084210600703009500291405736000723090000030941420900365109540000",
    s: "562398417917654283384217659743169528291485736856723194675832941428971365139546872",
    d: -20979,
  },
  {
    p: "563008000870090016219467350605830074307056000000700003086000135050680090032514687",
    s: "563128749874395216219467358625831974347956821198742563486279135751683492932514687",
    d: -20967,
  },
  {
    p: "060100000947500608810600035350260190009041050201300086006812079105937064090400321",
    s: "563189742947523618812674935354268197689741253271395486436812579125937864798456321",
    d: -20967,
  },
  {
    p: "003817920007960530008350600056040312004090800080506090800170260032685149605029700",
    s: "563817924127964538498352671956748312374291856281536497849173265732685149615429783",
    d: -20967,
  },
  {
    p: "500309208100060459090851603723086945910724806480000020601078300000012000872400001",
    s: "567349218138267459294851673723186945915724836486935127641578392359612784872493561",
    d: -20967,
  },
  {
    p: "500007010240901083139004270724000000891420060600008120000140600006002931315689742",
    s: "568237419247961583139854276724316895891425367653798124972143658486572931315689742",
    d: -20979,
  },
  {
    p: "568321007031406258000895061700050900080060512095000004072580000054902730019007805",
    s: "568321497931476258247895361726154983483769512195238674672583149854912736319647825",
    d: -20979,
  },
  {
    p: "008700490010240786400000013900473005005180947004502801000850620046029150850614370",
    s: "568731492319245786427968513981473265235186947674592831193857624746329158852614379",
    d: -20967,
  },
  {
    p: "060010873008035009370006415410003060835000102900040007054380790001507380783064250",
    s: "569412873148735629372896415417253968835679142926148537254381796691527384783964251",
    d: -20979,
  },
  {
    p: "572001690018650207630080410004120370297003561061700002000900004906578120005000086",
    s: "572431698418659237639287415854126379297843561361795842183962754946578123725314986",
    d: -20979,
  },
  {
    p: "570009800039518702048070000200437018401950076357086420960000087705090000020001954",
    s: "572649831639518742148273695296437518481952376357186429964325187715894263823761954",
    d: -20979,
  },
  {
    p: "000000000346251790019070205407003810030784509680192000120430900700925083953610000",
    s: "572849631346251798819376245497563812231784569685192374128437956764925183953618427",
    d: -20979,
  },
  {
    p: "573006080020381070981050060040700601352109748160820059005900816008570002200608500",
    s: "573296184426381975981457263849735621352169748167824359735942816618573492294618537",
    d: -20967,
  },
  {
    p: "504800060281569370093024581108306009000201008340070020950002613412637090806000000",
    s: "574813962281569374693724581128346759769251438345978126957482613412637895836195247",
    d: -20967,
  },
  {
    p: "000900123060205047082030090040702301820356974900000650708003415256041039013070000",
    s: "574968123369215847182437596645792381821356974937184652798623415256841739413579268",
    d: -20979,
  },
  {
    p: "574080020629001308003526090361090085057630910042010003790368240400002800030100007",
    s: "574983126629471358183526794361297485857634912942815673795368241416752839238149567",
    d: -20979,
  },
  {
    p: "506208314203504896489036520030000145164902030708040900891425070000000200007810000",
    s: "576298314213574896489136527932687145164952738758341962891425673345769281627813459",
    d: -20967,
  },
  {
    p: "570300009003972000000008073020046708360200500147080006634025800010039657759861342",
    s: "576314289483972165291658473925146738368297514147583926634725891812439657759861342",
    d: -20967,
  },
  {
    p: "500302409600000007421070305036825000840013050700600820207509000309107502154036798",
    s: "578362419693451287421978365936825174842713956715694823287549631369187542154236798",
    d: -20979,
  },
  {
    p: "500069021060100405491500786847210903006390817003670540704050138689701000000000000",
    s: "578469321362187495491523786847215963256394817913678542724956138689731254135842679",
    d: -20979,
  },
  {
    p: "070000403001300678600004910158920060402613007006048091800700139917436502325000000",
    s: "579861423241395678683274915158927364492613857736548291864752139917436582325189746",
    d: -20979,
  },
  {
    p: "582900000009003001001058002690520043034189560057346290906815024400702005825600000",
    s: "582971436749263851361458972698527143234189567157346298976815324413792685825634719",
    d: -20967,
  },
  {
    p: "503601200907320060040070130006000013894003005031056820370562480020009006405107392",
    s: "583691247917324568642875139256748913894213675731956824379562481128439756465187392",
    d: -20979,
  },
  {
    p: "000690104701034590640052378200000030010208905090543001062080050478320000930416702",
    s: "583697124721834596649152378254961837316278945897543261162789453478325619935416782",
    d: -20979,
  },
  {
    p: "580700100004020687060840050007450201038106905451300806325917460146285700000000000",
    s: "583769124914523687762841359697458231238176945451392876325917468146285793879634512",
    d: -20979,
  },
  {
    p: "580360109071589340209010580163720090058090000702004610000146900346050001010200468",
    s: "584362179671589342239417586163725894458691237792834615827146953346958721915273468",
    d: -20967,
  },
  {
    p: "500609007012030408370180000958003002040007001701000084867000029493572816125968000",
    s: "584629137612735498379184265958413672246897351731256984867341529493572816125968743",
    d: -20979,
  },
  {
    p: "500607132030451080000328000670234000308910070045086290800143700900060340013509620",
    s: "584697132236451987791328564679234815328915476145786293862143759957862341413579628",
    d: -20979,
  },
  {
    p: "584016293009300601003925070176802049438079000000600738865103027291460000000000000",
    s: "584716293729384651613925874176832549438579162952641738865193427291467385347258916",
    d: -20979,
  },
  {
    p: "000092417000681000109500300471206839002009105000013700310065248200708651608124900",
    s: "586392417743681592129547386471256839832479165965813724317965248294738651658124973",
    d: -20967,
  },
  {
    p: "009372004007600090260048300003000001020130675006820943002403710705289406834761020",
    s: "589372164347615892261948357473596281928134675156827943692453718715289436834761529",
    d: -20967,
  },
  {
    p: "089400031724000860160875492030080607010000050270510084800923046602040503000006928",
    s: "589462731724391865163875492935284617418637259276519384857923146692148573341756928",
    d: -20979,
  },
  {
    p: "000034120017002963600091850045003080398000200762905431074008016030467502050019000",
    s: "589634127417852963623791854145273689398146275762985431974528316831467592256319748",
    d: -20979,
  },
  {
    p: "001380070603400051748010306057003042010740005230900000080637519170500683365198000",
    s: "591386274623479851748215396957863142816742935234951768482637519179524683365198427",
    d: -20967,
  },
  {
    p: "501020847200517600003890100452938000700001089009006000064109320300005906915362478",
    s: "591623847248517693673894152452938761736241589189756234864179325327485916915362478",
    d: -20967,
  },
  {
    p: "591020034620037189308049200806450970902073605007900000480300000015000800760085491",
    s: "591628734624537189378149256836451972942873615157962348489316527215794863763285491",
    d: -20979,
  },
  {
    p: "590000070700006200806745913600159832908630400050874106472561380005390700089000000",
    s: "594213678731986245826745913647159832918632457253874196472561389165398724389427561",
    d: -20967,
  },
  {
    p: "504087003708040609361259084005094000240830075073000418002408007400000060007926541",
    s: "594687123728143659361259784185794236246831975973562418652418397419375862837926541",
    d: -20979,
  },
  {
    p: "098100600240760859637580401400870002002034080983620100019056200850207903000008015",
    s: "598142637241763859637589421465871392172934586983625174719356248854217963326498715",
    d: -20967,
  },
  {
    p: "002003000847506231900000000059760382724001069306020147260800953590030004400059628",
    s: "612473895847596231935218476159764382724381569386925147261847953598632714473159628",
    d: -20967,
  },
  {
    p: "010047009802001607009080214020000300000004106360109802931062758400705920275908463",
    s: "613247589842591637759683214124876395598324176367159842931462758486735921275918463",
    d: -20967,
  },
  {
    p: "600247008748000000920831476030684017000590864000002059057020981400009023290000645",
    s: "613247598748965132925831476539684217172593864864712359357426981486159723291378645",
    d: -20979,
  },
  {
    p: "613000000750260000824015070085403096100000702497106085901000058070542001062081437",
    s: "613798524759264813824315679285473196136859742497126385941637258378542961562981437",
    d: -20979,
  },
  {
    p: "613872004009501300800940017006005001001097063348006095930650078164008030000139400",
    s: "613872954479561382825943617796385241251497863348216795932654178164728539587139426",
    d: -20979,
  },
  {
    p: "610950004048076005250431008831049052009700301024315800080090620400000009002567483",
    s: "613958274948276135257431968831649752569782341724315896385194627476823519192567483",
    d: -20967,
  },
  {
    p: "014097003783064291295138076876300142040016057300002000160700030000980620000600009",
    s: "614297583783564291295138476876359142942816357351472968169725834437981625528643719",
    d: -20979,
  },
  {
    p: "610200037200500401034000260050926703070058642002017009890000020003002956521694378",
    s: "615249837287563491934871265458926713179358642362417589896735124743182956521694378",
    d: -20967,
  },
  {
    p: "010089400487350009329000060870425093230060045954010680040600900000500804590841306",
    s: "615289437487356219329174568876425193231968745954713682748632951163597824592841376",
    d: -20979,
  },
  {
    p: "600920048000005610083160009060003405201540080004206931170038000500790163092651874",
    s: "615927348429385617783164259967813425231549786854276931176438592548792163392651874",
    d: -20967,
  },
  {
    p: "007080059524931600809765014052670090083520701970013520768300005200000806340800000",
    s: "617284359524931687839765214152678493483529761976413528768392145295147836341856972",
    d: -20967,
  },
  {
    p: "609054000530086009000070561800402600065897314370501980150748003980015006043000008",
    s: "619254837537186429428973561891432675265897314374561982156748293982315746743629158",
    d: -20979,
  },
  {
    p: "609304005852971000003020001408097036370050010190043208204005000081000057567819342",
    s: "619384725852971463743526891428197536376258914195643278234765189981432657567819342",
    d: -20967,
  },
  {
    p: "009548002802000640500607189700800010408009026000465830085074201060351490004086703",
    s: "619548372872193645543627189756832914438719526921465837385974261267351498194286753",
    d: -20979,
  },
  {
    p: "021059084090000000053826091000098150815270060976105000100087005340000208087342619",
    s: "621759384798413526453826791234698157815274963976135842162987435349561278587342619",
    d: -20979,
  },
  {
    p: "620800039803601000975034860590400217387109005210067983100748300032000500060302000",
    s: "621875439843691752975234861596483217387129645214567983159748326432916578768352194",
    d: -20967,
  },
  {
    p: "003109845851046700974820301012600400068000207549000683186037904090000008005200100",
    s: "623179845851346792974825361712683459368954217549712683186537924297461538435298176",
    d: -20979,
  },
  {
    p: "624000105705020039038506007402038500386005740109042060803050000561389200207001003",
    s: "624973185715824639938516427472638591386195742159742368843257916561389274297461853",
    d: -20979,
  },
  {
    p: "000090430009760105017304800970000516850600273200007908402800351163900080705401692",
    s: "628195437349768125517324869974283516851649273236517948492876351163952784785431692",
    d: -20967,
  },
  {
    p: "020491503039780140017650209056140038073028465000065721000800010700039054800510000",
    s: "628491573539782146417653289256147938173928465984365721395874612761239854842516397",
    d: -20967,
  },
  {
    p: "620590137001603802050002064015068320296340008003250601060905003002087000079430080",
    s: "628594137941673852357812964415768329296341578783259641864925713532187496179436285",
    d: -20979,
  },
  {
    p: "620900317000728659795060028036810004001604700547293001174030980059106003000000100",
    s: "628945317413728659795361428236817594981654732547293861174532986859176243362489175",
    d: -20967,
  },
  {
    p: "029407350800003002031052604904201080250009041170500000010738409497100030080045217",
    s: "629417358845693172731852694964271583258369741173584926512738469497126835386945217",
    d: -20979,
  },
  {
    p: "000704500700620094304908020540832976000001843003479010958047362430200700102380000",
    s: "629714538785623194314958627541832976297561843863479215958147362436295781172386459",
    d: -20967,
  },
  {
    p: "630027109027094035015830204009003460080060007040780900050602091008041056000958342",
    s: "634527189827194635915836274579213468382469517146785923453672891298341756761958342",
    d: -20979,
  },
  {
    p: "600090210140756890980210064471580639820609140506340080068905000014020056700000000",
    s: "635498217142756893987213564471582639823679145596341782268935471314827956759164328",
    d: -20967,
  },
  {
    p: "007902004000053900090746231213084679409300102760109503371608025904070006000000008",
    s: "637912854142853967895746231213584679459367182768129543371698425984275316526431798",
    d: -20979,
  },
  {
    p: "630190027050007030070080609000076190083910240109208000300800001805731462217460380",
    s: "638194527951627834472583619524376198783915246169248753346852971895731462217469385",
    d: -20979,
  },
  {
    p: "008740210071689504405013000060001700000378490780900100016500807043067950527894000",
    s: "638745219271689534495213678369421785152378496784956123916532847843167952527894361",
    d: -20979,
  },
  {
    p: "039004180150090042700581003090832000010465879860719030901650000203047056540020300",
    s: "639274185158396742724581693497832561312465879865719234971653428283147956546928317",
    d: -20967,
  },
  {
    p: "002700013809200745730009026090502460000078009586093170063000280908000650050861397",
    s: "642785913819236745735149826397512468421678539586493172163957284978324651254861397",
    d: -20979,
  },
  {
    p: "642010309730056810000293740805062400020300561000000008073628100096700280280500674",
    s: "642817359739456812158293746815962437927384561364175928473628195596741283281539674",
    d: -20979,
  },
  {
    p: "602803000300974820700201350000537248074018009850020700030100682000786400186340900",
    s: "642853197315974826798261354961537248274618539853429761437195682529786413186342975",
    d: -20979,
  },
  {
    p: "603570091290060437080900650700206000800309174030817026001783269002090010000021345",
    s: "643572891295168437187934652719246583826359174534817926451783269362495718978621345",
    d: -20967,
  },
  {
    p: "605002983000439000309080020000065179950001006168073542002000604030054098090628317",
    s: "645712983281439765379586421423865179957241836168973542812397654736154298594628317",
    d: -20979,
  },
  {
    p: "647835900025100030800070405008710200200498350190000080502940070719680524460007008",
    s: "647835912925164837831279465358716249276498351194352786582941673719683524463527198",
    d: -20979,
  },
  {
    p: "008350000000024036203687040006512000125038000300796201860105093019040768037000512",
    s: "648351927751924836293687145976512384125438679384796251862175493519243768437869512",
    d: -20979,
  },
  {
    p: "600203870340000001000571004960730180070900003283154700516087032000629017720310608",
    s: "651243879347896251892571364964732185175968423283154796516487932438629517729315648",
    d: -20967,
  },
  {
    p: "051278900030965270700004000485090020000502080210400795942001367563740002100026040",
    s: "651278934834965271729134658485697123397512486216483795942851367563749812178326549",
    d: -20979,
  },
  {
    p: "051290730972340086438507910086900000043605107509002068890170203027050640300000000",
    s: "651298734972341586438567912786914325243685197519732468894176253127853649365429871",
    d: -20967,
  },
  {
    p: "000700018710695030490280675200000840140867000007302100001000000304178529875923461",
    s: "652734918718695234493281675236519847149867352587342196921456783364178529875923461",
    d: -20967,
  },
  {
    p: "050800439800500021043000850280057103009416580561030790000760215005082970026105300",
    s: "652871439897543621143629857284957163379416582561238794938764215415382976726195348",
    d: -20967,
  },
  {
    p: "000913740900780050078200010045639187086100300300072060100008035023060470504397821",
    s: "652913748931784256478256913245639187786145392319872564197428635823561479564397821",
    d: -20967,
  },
  {
    p: "652947018300200654810603009120065907009032060000079800001300006065008003703096281",
    s: "652947318397281654814653729128465937479832165536179842981324576265718493743596281",
    d: -20979,
  },
  {
    p: "600100470000650380800004000498000703015803240206741098520078900984026130007009825",
    s: "653182479149657382872934651498265713715893246236741598521378964984526137367419825",
    d: -20979,
  },
  {
    p: "050201307700496802000735040006000074932074508507002009060140983400003061000968425",
    s: "654281397713496852829735146186359274932674518547812639265147983498523761371968425",
    d: -20979,
  },
  {
    p: "054090820000580100003007956390102704427608091165904080009800670006729010781400000",
    s: "654391827972586143813247956398152764427638591165974382249813675536729418781465239",
    d: -20979,
  },
  {
    p: "657098031009051670103000000000805020720060098530900167000600802870210350302589746",
    s: "657498231289351674143726985961875423724163598538942167495637812876214359312589746",
    d: -20979,
  },
  {
    p: "000000700029507038003906020506400902000801457704290063090004000261008594347159286",
    s: "658312749129547638473986125586473912932861457714295863895624371261738594347159286",
    d: -20979,
  },
  {
    p: "609108472024056100130207000006412000943060000200089700500804930480500607097021845",
    s: "659138472724956183138247596876412359943765218215389764562874931481593627397621845",
    d: -20979,
  },
  {
    p: "009008003140007080007630900000865049904723018835109600091072004026081005378456090",
    s: "659218473143597286287634951712865349964723518835149627591372864426981735378456192",
    d: -20967,
  },
  {
    p: "009040001700028095042090736010870020020364800360209570203956148196480000000000967",
    s: "659743281731628495842591736914875623527364819368219574273956148196487352485132967",
    d: -20979,
  },
  {
    p: "609041230000003001123000008200530710097406020810902643540309170980060350700104902",
    s: "659841237478623591123795468264538719397416825815972643542389176981267354736154982",
    d: -20979,
  },
  {
    p: "670000954014572003008060170201094080003210649700856020007000006020001790096728415",
    s: "672183954914572863538469172261394587853217649749856321187945236425631798396728415",
    d: -20979,
  },
  {
    p: "602090183950371200000208050783052400260104508500780362300010020000943715405007000",
    s: "672495183958371246134268957783652491269134578541789362397516824826943715415827639",
    d: -20979,
  },
  {
    p: "673108004009675010050003679532460980091500040040000530204856397060009008000024165",
    s: "673198254429675813158243679532467981891532746746981532214856397365719428987324165",
    d: -20967,
  },
  {
    p: "003084009050972346209306058527400061300760290400008570085641002062030005030059000",
    s: "673584129851972346249316758527493861318765294496128573785641932962837415134259687",
    d: -20979,
  },
  {
    p: "000908021832040596501300008928007004067092000410000000200604010789105060146279853",
    s: "674958321832741596591326748928517634367492185415863279253684917789135462146279853",
    d: -20979,
  },
  {
    p: "670842009000060270492017006760483002053090407920005038340028090507000621219050003",
    s: "675842319138569274492317586761483952853291467924675138346128795587934621219756843",
    d: -20967,
  },
  {
    p: "000903152103002748502700300415208073089010620200304000006805010904006805001439267",
    s: "678943152193652748542781396415268973389517624267394581736825419924176835851439267",
    d: -20967,
  },
  {
    p: "670100850030985060010607249006010532000568490591304670143076905700491080000000000",
    s: "679142853234985167815637249486719532327568491591324678143876925752491386968253714",
    d: -20979,
  },
  {
    p: "679200850354968100820700639200040006030027005006809700065103200190500008783490001",
    s: "679231854354968172821754639217345986938627415546819723465183297192576348783492561",
    d: -20979,
  },
  {
    p: "009245813015009040800003790481502000050010080207408350000601470700354100024987536",
    s: "679245813315879642842163795481532967953716284267498351538621479796354128124987536",
    d: -20967,
  },
  {
    p: "670500000100207009005619734702056108561824973400301005056702481007430290900000000",
    s: "679543812143287569285619734732956148561824973498371625356792481817435296924168357",
    d: -20967,
  },
  {
    p: "005090102040020000921756000507408901000513087816079053059107208402005310168930000",
    s: "685394172743821596921756834537468921294513687816279453359147268472685319168932745",
    d: -20967,
  },
  {
    p: "087103250235478960109560800401800020806201093923607508000325109094000382000000000",
    s: "687193254235478961149562837451839726876251493923647518768325149594716382312984675",
    d: -20967,
  },
  {
    p: "087041253050080941104320007501070090376209018940103725000500104002600000000098632",
    s: "687941253253786941194325867521874396376259418948163725869532174432617589715498632",
    d: -20979,
  },
  {
    p: "090700000451030806000106439879504001010370008320861795947005003260000957035207004",
    s: "693748512451932876782156439879524361516379248324861795947685123268413957135297684",
    d: -20967,
  },
  {
    p: "004107582000065003001209406742008030185320700000054028403092867026800354857003000",
    s: "694137582278465913531289476742918635185326749369754128413592867926871354857643291",
    d: -20967,
  },
  {
    p: "005340782008005609002960530800012050050096004409537000010050006200680415586124397",
    s: "695341782138275649742968531867412953351896274429537168914753826273689415586124397",
    d: -20967,
  },
  {
    p: "600030284340980060700620539010200803063070001078003620000047058057890316039156000",
    s: "695731284342985167781624539514269873263578491978413625126347958457892316839156742",
    d: -20979,
  },
  {
    p: "098000570530900064204080009187306290050810607300702480740200000000073900913564728",
    s: "698431572531927864274685319187346295452819637369752481746298153825173946913564728",
    d: -20979,
  },
  {
    p: "008030241000801963021046578069080317503719826087000400035100600070304082400000005",
    s: "698537241754821963321946578269485317543719826187263459835172694976354182412698735",
    d: -20979,
  },
  {
    p: "690004321051802069432001570009465000370009685005007004940210856020950000003706102",
    s: "698574321751832469432691578819465237374129685265387914947213856126958743583746192",
    d: -20967,
  },
  {
    p: "098001054430600090510904003180390042000856300703002509370140805804560910000078436",
    s: "698731254437625198512984763185397642249856371763412589376149825824563917951278436",
    d: -20967,
  },
  {
    p: "012509036953046780480000009801950203045600807279034560590700300120000605030020018",
    s: "712589436953146782486273159861957243345612897279834561598761324124398675637425918",
    d: -20967,
  },
  {
    p: "713900582024837000009520040002358401000704258085219736908170024050002870000000900",
    s: "713946582524837169869521347672358491391764258485219736938175624156492873247683915",
    d: -20967,
  },
  {
    p: "014650800580000709396287000405030108000800054078502090257104983830725041641000000",
    s: "714659832582413769396287415425936178963871254178542396257164983839725641641398527",
    d: -20967,
  },
  {
    p: "710240690200651700603000002356010007000700400479502030067328510030100280180495076",
    s: "715243698298651743643987152356814927821739465479562831967328514534176289182495376",
    d: -20979,
  },
  {
    p: "710208963600037100300005072874092531000004006096081000060010200031859647957426000",
    s: "715248963642937185389165472874692531123574896596381724468713259231859647957426318",
    d: -20967,
  },
  {
    p: "015400639802935070403601002007019243000540790049067008008300967934086125070000000",
    s: "715428639862935471493671852657819243281543796349267518128354967934786125576192384",
    d: -20967,
  },
  {
    p: "700092046500607300060000790030416080000875903056209071170504839384020057605080100",
    s: "718392546529647318463158792937416285241875963856239471172564839384921657695783124",
    d: -20979,
  },
  {
    p: "018060240529743108003028597130270080905080002086901750007050901092304800000090420",
    s: "718569243529743168463128597134275689975486312286931754847652931692314875351897426",
    d: -20967,
  },
  {
    p: "010602509000004300943157286005400791064009800000503462452361900001020000087905123",
    s: "718632549526894317943157286235486791164279835879513462452361978391728654687945123",
    d: -20967,
  },
  {
    p: "709032054002800700803094612000000060060348107237006008321580496590063271076100000",
    s: "719632854642851739853794612184275963965348127237916548321587496598463271476129385",
    d: -20967,
  },
  {
    p: "003610854000084006864057020005062008002900015490135670907400060056870903340506200",
    s: "723619854519284736864357129135762498672948315498135672987423561256871943341596287",
    d: -20979,
  },
  {
    p: "724015090090002175651709320302407901500003700006090032040008060030006417965074200",
    s: "724315698893642175651789324382467951519823746476591832147238569238956417965174283",
    d: -20979,
  },
  {
    p: "004609100980271064000405090003542916060010007150006040307150000200364570516927008",
    s: "724639185985271364631485792873542916469813257152796843347158629298364571516927438",
    d: -20979,
  },
  {
    p: "025138600610402058000570013004850320879263045300040069081000006000987501007010482",
    s: "725138694613492758498576213164859327879263145352741869581324976246987531937615482",
    d: -20967,
  },
  {
    p: "020083001094102000381907060243095006078420359000031720407250090905374010832000070",
    s: "726583941594162837381947562243795186178426359659831724417258693965374218832619475",
    d: -20967,
  },
  {
    p: "028403601160500320530016790810602003200841006600700800350004080000027435070385269",
    s: "728493651169578324534216798817652943293841576645739812352964187986127435471385269",
    d: -20967,
  },
  {
    p: "700020045042905308089037006053840210018702560270000000095204631060003002320169800",
    s: "731628945642915378589437126953846217418792563276351489895274631164583792327169854",
    d: -20979,
  },
  {
    p: "702800056086030200540060030400908100250006073007023608009054082874092500305601794",
    s: "732819456986435217541267839463978125258146973197523648619754382874392561325681794",
    d: -20979,
  },
  {
    p: "705000086491863200008709400087015300100300500002970810060507100003291648210608759",
    s: "735124986491863275628759431987415362146382597352976814869547123573291648214638759",
    d: -20967,
  },
  {
    p: "730060481890000000210370000000000048582000076070090520008745369640931850953682014",
    s: "735269481896154237214378695369527148582413976471896523128745369647931852953682714",
    d: -20979,
  },
  {
    p: "730045008164200970520197463092080051607000834000300700480902010271000080956013000",
    s: "739645128164238975528197463392784651617529834845361792483972516271456389956813247",
    d: -20979,
  },
  {
    p: "740860501000200600800509002316900725004005109980007060097312050028006043053498217",
    s: "742863591539241678861579432316984725274635189985127364497312856128756943653498217",
    d: -20967,
  },
  {
    p: "000260158001078000800304096500080309089450020017002845470600080038725004296003517",
    s: "743269158961578432852314796524186379389457621617932845475691283138725964296843517",
    d: -20979,
  },
  {
    p: "000002308290348057300070492070009080984610073600704915069407501120003046050001029",
    s: "745192368296348157318576492571239684984615273632784915869427531127953846453861729",
    d: -20967,
  },
  {
    p: "740206918923100007086509203801403075560807000207600481608902704309084006000000000",
    s: "745236918923148567186579243891423675564817392237695481618952734359784126472361859",
    d: -20979,
  },
  {
    p: "745328106019705820000961574073600901000004380208009007300200000080413200020897405",
    s: "745328196619745823832961574473682951961574382258139647394256718587413269126897435",
    d: -20979,
  },
  {
    p: "745800012690040078081972650150726400426508000830009020008304267904007030003600040",
    s: "745863912692145378381972654159726483426538791837419526518394267964287135273651849",
    d: -20967,
  },
  {
    p: "700905003301000090928403650070086902639000001480109065510607400290834516804000700",
    s: "746925183351768294928413657175386942639542871482179365513697428297834516864251739",
    d: -20979,
  },
  {
    p: "700930501819560273020081046680047092902658007001300600007296834008470020004000060",
    s: "746932581819564273523781946685147392932658417471329658157296834368475129294813765",
    d: -20967,
  },
  {
    p: "708030052602095081519008030091040570003002469456800120300081005900050800000264397",
    s: "748136952632495781519728634291643578873512469456879123367981245924357816185264397",
    d: -20979,
  },
  {
    p: "000006050002180407003047600401500302605371800089604175000850010536712948007460520",
    s: "748936251962185437153247689471598362625371894389624175294853716536712948817469523",
    d: -20967,
  },
  {
    p: "709200810250170004000000750030480567800630420624007098493761285502908173100000000",
    s: "749253816258176934316894752931482567875639421624517398493761285562948173187325649",
    d: -20967,
  },
  {
    p: "740603010003750206526180074092005048470908102360400750207891063600500001900206000",
    s: "749623815813754296526189374192375648475968132368412759257891463684537921931246587",
    d: -20967,
  },
  {
    p: "050003000608950740140287500007020031580100000421039605306508274210376859875000000",
    s: "752643198638951742149287563967825431583164927421739685396518274214376859875492316",
    d: -20967,
  },
  {
    p: "050006140090312708103547620261408937908023015305001000600100090514030862000000500",
    s: "752896143496312758183547629261458937978623415345971286627185394514739862839264571",
    d: -20979,
  },
  {
    p: "000080920128093700046005010800160200090020450460309800087500130509837042034916587",
    s: "753681924128493765946275318875164293391728456462359871687542139519837642234916587",
    d: -20967,
  },
  {
    p: "750092380320607040608043710410026903285309004936750108100060007000400061800000435",
    s: "754192386321687549698543712417826953285319674936754128143265897579438261862971435",
    d: -20967,
  },
  {
    p: "704308206019672580682905070508700002960001003231080709006504907475009038100000000",
    s: "754318296319672584682945371548793162967251843231486759826534917475129638193867425",
    d: -20979,
  },
  {
    p: "708400196146908207009600458300284960000307542062105000010700029000009370800502014",
    s: "758423196146958237239671458375284961981367542462195783513746829624819375897532614",
    d: -20979,
  },
  {
    p: "700004023403590000208000504000900170041020036900301085030706240600238751172459368",
    s: "759184623463592817218673594386945172541827936927361485835716249694238751172459368",
    d: -20967,
  },
  {
    p: "700200306320007049084300502018694005903002608075038294000915460400006053507000021",
    s: "759241386326857149184369572218694735943572618675138294832915467491726853567483921",
    d: -20979,
  },
  {
    p: "759406028000000000182000700570264980640938500008175634010040067064001205807602013",
    s: "759416328436827159182593746573264981641938572928175634215349867364781295897652413",
    d: -20967,
  },
  {
    p: "059040000630700902820936047170658200002103005980027013010264759040379108000080000",
    s: "759842361634715982821936547173658294462193875985427613318264759546379128297581436",
    d: -20979,
  },
  {
    p: "063500049000400561041890237374008906050360702206709084105087493609000000000001625",
    s: "763512849892473561541896237374128956958364712216759384125687493639245178487931625",
    d: -20967,
  },
  {
    p: "763849000240010800180002460016090273390726100072008946400973015031205084000000000",
    s: "763849521245617839189352467816594273394726158572138946428973615931265784657481392",
    d: -20979,
  },
  {
    p: "060185020002470610108230000500001400001798002907503061476052000000060234239814576",
    s: "764185923352479618198236745583621497641798352927543861476352189815967234239814576",
    d: -20967,
  },
  {
    p: "764000850803046092590801460940103007280400300100287549050700028020950670000600905",
    s: "764329851813546792592871463945163287287495316136287549659734128321958674478612935",
    d: -20979,
  },
  {
    p: "060592310002013004109406200298004750000100003613070029501208930080057142900340580",
    s: "764592318852713694139486275298634751475129863613875429541268937386957142927341586",
    d: -20967,
  },
  {
    p: "000102300400003007031580064870320040310005689540861720050004030103050406200736951",
    s: "765142398428693517931587264876329145312475689549861723657914832193258476284736951",
    d: -20979,
  },
  {
    p: "765930024908067513320004079519470208080020005400809000873692051054708096000000000",
    s: "765931824948267513321584679519476238687123945432859167873692451254718396196345782",
    d: -20967,
  },
  {
    p: "700500003540708000326140075204305000800000306635907421078000004460091037903274168",
    s: "781526943549738612326149875214365789897412356635987421178653294462891537953274168",
    d: -20967,
  },
  {
    p: "082000163106280409090160200210604800368951040570000906627309080030040607800026091",
    s: "782495163156283479493167258219674835368951742574832916627319584931548627845726391",
    d: -20967,
  },
  {
    p: "082040009410009607309807000090503704603090001004708000248176300037480216156032470",
    s: "782641539415329687369857142891563724673294851524718963248176395937485216156932478",
    d: -20967,
  },
  {
    p: "703000240209408107040050389496127050078096412100304700034000628900000570007205034",
    s: "783619245259438167641752389496127853378596412125384796534971628962843571817265934",
    d: -20967,
  },
  {
    p: "704300900510029070320710506090173600175900800000500100030000060450697231261438759",
    s: "784365912516829374329714586892173645175946823643582197937251468458697231261438759",
    d: -20967,
  },
  {
    p: "000500000300278090090403087278650403009730806653100200060807301027301960431965700",
    s: "784596132316278594592413687278659413149732856653184279965827341827341965431965728",
    d: -20967,
  },
  {
    p: "084009021903201674610073009000012086326048190041796035408900500100020000060005948",
    s: "784659321953281674612473859579312486326548197841796235438967512195824763267135948",
    d: -20967,
  },
  {
    p: "780950006900276048003000050000500600020009781300860500100705003839612475657348102",
    s: "784953216915276348263184957478521639526439781391867524142795863839612475657348192",
    d: -20979,
  },
  {
    p: "080203614000100002003050907007018003914305208508024009302001706879502341041739000",
    s: "785293614496187532123456987267918453914375268538624179352841796879562341641739825",
    d: -20967,
  },
  {
    p: "706004100002007689950608204020400500100062300095003410000840931800296700049371826",
    s: "786924153432157689951638274328419567174562398695783412267845931813296745549371826",
    d: -20979,
  },
  {
    p: "701060058053010409002859310008001546006543981010098032025900074067420090480000000",
    s: "791364258853712469642859317938271546276543981514698732325986174167425893489137625",
    d: -20979,
  },
  {
    p: "793256400205801690806934005082049000967083124004000030670000002021000050008762941",
    s: "793256418245871693816934275382149567967583124154627839679415382421398756538762941",
    d: -20967,
  },
  {
    p: "003640805105280040408009600300924006080000200249100537504806312806410759010370000",
    s: "793641825165287943428539671357924186681753294249168537574896312836412759912375468",
    d: -20979,
  },
  {
    p: "005306410461572080823941507052008640900610308180234700607009100200407006040000000",
    s: "795386412461572983823941567352798641974615328186234795637829154219457836548163279",
    d: -20979,
  },
  {
    p: "790600348006389072200000060069402030400050001870063054650190003900538010014276985",
    s: "795621348146389572283745169569412837432857691871963254658194723927538416314276985",
    d: -20967,
  },
  {
    p: "706310852300082090020569030103906200068403010045071060500000024009230685002140903",
    s: "796314852351782496824569731173956248968423517245871369537698124419237685682145973",
    d: -20979,
  },
  {
    p: "706500400058600200412008009800029300034050907269300805500963100621400703983201040",
    s: "796512438358694271412738659875129364134856927269347815547963182621485793983271546",
    d: -20979,
  },
];
